export interface Survey {
  id: string
  userId: string
  surveyType: 'career_calling' | 'outcome_expectation' | 'bfi15'
  answers: Record<string, number>
  scores: Record<string, number>
  dominantDimension: string
  completedAt: Date
  version: string
  userName?: string
  // 時間追蹤欄位（optional，舊資料為 undefined）
  startedAt?: Date
  durationSeconds?: number
  questionTimings?: Record<string, number>
  isRetake?: boolean
  entrySource?: string
  pauseCount?: number
  totalPauseSeconds?: number
}

export const SURVEY_TYPE_LABELS: Record<string, string> = {
  career_calling: '成人生涯召喚量表',
  outcome_expectation: '結果預期量表',
  bfi15: 'BFI-15 五大人格量表',
}

export const SURVEY_DIMENSION_LABELS: Record<string, Record<string, string>> = {
  career_calling: {
    interest_passion: '興趣熱情',
    existential_meaning: '存在意義',
    altruism: '利他助人',
    transcendence: '超越奉獻',
  },
  outcome_expectation: {
    security: '安全',
    empowerment: '賦權',
    helping_others: '助人',
    flexibility: '彈性',
    opportunity: '機會',
  },
  bfi15: {
    extraversion: '外向性',
    agreeableness: '友善性',
    conscientiousness: '嚴謹性',
    neuroticism: '神經質',
    openness: '開放性',
  },
}

export const SURVEY_MAX_SCORES: Record<string, number> = {
  career_calling: 4,
  outcome_expectation: 8,
  bfi15: 15,
}
